import { AuthenticationMethod } from '../../../user/detail/components/mfa/AuthenticationMethod';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

interface EnrollmentTicketResponse {
    ticketId: string;
    ticketUrl: string;
}

interface RecoveryCodeResponse {
    recoveryCode: string;
}

interface AuthenticationMethodListResponse {
    content: AuthenticationMethod[];
}

interface DeleteAuthenticationMethodParams {
    authenticationMethodId: string;
}

export const getAuthenticationMethods = async (): Promise<AuthenticationMethodListResponse> => {
    const response = await authorizedAxiosInstance.get('/v2/users/mfa/authentication-methods');
    return response.data;
};

export const getManagementUserAuthenticationMethods = async (
    userId: string
): Promise<AuthenticationMethodListResponse> => {
    const response = await authorizedAxiosInstance.get(`/v2/users/management/mfa/${userId}/authentication-methods`);
    return response.data;
};

export const generateEnrollmentTicket = async (): Promise<EnrollmentTicketResponse> => {
    const response = await authorizedAxiosInstance.post('/v2/users/mfa/enrollment-ticket');
    return response.data;
};

export const generateRecoveryCode = async (): Promise<RecoveryCodeResponse> => {
    const response = await authorizedAxiosInstance.post('/v2/users/mfa/recovery-code');
    return response.data;
};

export const deleteAuthenticationMethod = async ({
    authenticationMethodId,
}: DeleteAuthenticationMethodParams): Promise<void> => {
    const encodedId = encodeURIComponent(authenticationMethodId);
    await authorizedAxiosInstance.delete(`/v2/users/mfa/authentication-methods/${encodedId}`);
};

interface DeleteManagementAuthenticationMethodParams {
    authenticationMethodId: string;
    userId: string;
}

export const deleteManagementAuthenticationMethod = async ({
    authenticationMethodId,
    userId,
}: DeleteManagementAuthenticationMethodParams): Promise<void> => {
    const encodedId = encodeURIComponent(authenticationMethodId);
    await authorizedAxiosInstance.delete(`/v2/users/management/mfa/${userId}/authentication-methods/${encodedId}`);
};
